import { log } from '@/utils/log';

interface IPageSizeWatcher {
  dispatch: (params: IPageSizeDiapatchParams, isOnload?: boolean) => void;
  off: (cb: (params: IPageSizeDiapatchParams) => void) => void;
  on: (cb: (params: IPageSizeDiapatchParams) => void) => void;
  cbs: { (params: IPageSizeDiapatchParams): void }[];
}
interface IPageSizeWatcherCtr {
  new (): IPageSizeWatcher;
  prototype: IPageSizeWatcher;
}

export type IPageSizeDiapatchParams = {
  width: number;
  height: number;
  type: 's' | 'm' | 'l' | 'xl' | 'xxl';
};

const getType = (width: number) => {
  if (width < 1280) {
    return 's';
  }
  if (width < 1441) {
    return 'm';
  }
  if (width < 1561) {
    return 'l';
  }
  if (width < 1921) {
    return 'xl';
  }
  return 'xxl';
};
let pageSizeDiapatchParams: IPageSizeDiapatchParams;

const PageSizeWatcherCtr = function (this: IPageSizeWatcher) {
  this.cbs = [];
} as unknown as IPageSizeWatcherCtr;
PageSizeWatcherCtr.prototype.on = function (
  cb: (params: IPageSizeDiapatchParams) => any
) {
  if (typeof cb !== 'function') {
    log.error(`cb 应该是一个 function，但是实际传递类型是：${typeof cb}`);
    return;
  }
  this.cbs.push(cb);
  if (this.cbs.length === 1) {
    bindEvent();
  }
};
PageSizeWatcherCtr.prototype.off = function (
  cb: (params: IPageSizeDiapatchParams) => any
) {
  if (typeof cb !== 'function') {
    // eslint-disable-next-line no-console
    log.error(`cb 应该是一个 function，但是实际传递类型是：${typeof cb}`);
    return;
  }

  this.cbs.forEach((cb: (params: IPageSizeDiapatchParams) => any) => {
    const i = this.cbs.indexOf(cb);

    this.cbs.splice(i, 1);

    if (this.cbs.length === 0) {
      unbindEvent();
    }
  });
};
PageSizeWatcherCtr.prototype.dispatch = function (
  params: IPageSizeDiapatchParams,
  isOnload
) {
  const { type } = params || {};
  const { type: typeNew } = pageSizeDiapatchParams || {};

  // 仅断点类型改变是再触发回调
  if (type === typeNew && !isOnload) {
    return;
  }

  pageSizeDiapatchParams = {
    ...params,
  };
  this.cbs.forEach((cb: (params: IPageSizeDiapatchParams) => any) => {
    cb(params);
  });
};
const pageSizeWatcher = new PageSizeWatcherCtr();

function bindEventCb(_e: any, isOnload?: boolean) {
  const width = document.documentElement.clientWidth;
  const height = document.documentElement.clientHeight;
  const type = getType(width);

  pageSizeWatcher.dispatch({ width, height, type }, isOnload);
}
function bindEvent() {
  window.addEventListener('resize', bindEventCb);
}
function unbindEvent() {
  window.removeEventListener('resize', bindEventCb);
}

// 页面首次加载触发一次
window.addEventListener('load', (e) => {
  // 经测试，使用 setTimeout 400 毫秒可以迟于 useEffect 回调的触发
  setTimeout(() => {
    bindEventCb(e, true);
  }, 400);
});

export default pageSizeWatcher;
